/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keep_Window_Open_Until_Upload_CompleteInputs */

const en_keep_window_open_until_upload_complete = /** @type {(inputs: Keep_Window_Open_Until_Upload_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please leave this window open until your upload completes.`)
};

const fr_keep_window_open_until_upload_complete = /** @type {(inputs: Keep_Window_Open_Until_Upload_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez laisser cette fenêtre ouverte jusqu’à la fin du téléversement.`)
};

const de_keep_window_open_until_upload_complete = /** @type {(inputs: Keep_Window_Open_Until_Upload_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte lassen Sie dieses Fenster so lange geöffnet, bis Ihr Upload abgeschlossen ist.`)
};

const it_keep_window_open_until_upload_complete = /** @type {(inputs: Keep_Window_Open_Until_Upload_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lascia questa finestra aperta fino al completamento del caricamento.`)
};

const ru_keep_window_open_until_upload_complete = /** @type {(inputs: Keep_Window_Open_Until_Upload_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, оставьте это окно открытым до завершения загрузки.`)
};

const es_keep_window_open_until_upload_complete = /** @type {(inputs: Keep_Window_Open_Until_Upload_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deje esta ventana abierta hasta que se complete la carga.`)
};

const zh_cn2_keep_window_open_until_upload_complete = /** @type {(inputs: Keep_Window_Open_Until_Upload_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请保持此窗口打开，直到上传完成。`)
};

const ja_keep_window_open_until_upload_complete = /** @type {(inputs: Keep_Window_Open_Until_Upload_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アップロードが完了するまでこのウィンドウを開いたままにしてください。`)
};

const hi_keep_window_open_until_upload_complete = /** @type {(inputs: Keep_Window_Open_Until_Upload_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया अपलोड पूरा होने तक इस विंडो को खुला रखें।`)
};

const pt_pt2_keep_window_open_until_upload_complete = /** @type {(inputs: Keep_Window_Open_Until_Upload_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, mantenha esta janela aberta até que o seu upload seja concluído.`)
};

/**
* | output |
* | --- |
* | "Please leave this window open until your upload completes." |
*
* @param {Keep_Window_Open_Until_Upload_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const keep_window_open_until_upload_complete = /** @type {((inputs?: Keep_Window_Open_Until_Upload_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keep_Window_Open_Until_Upload_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_keep_window_open_until_upload_complete(inputs)
	if (locale === "de") return de_keep_window_open_until_upload_complete(inputs)
	if (locale === "it") return it_keep_window_open_until_upload_complete(inputs)
	if (locale === "ru") return ru_keep_window_open_until_upload_complete(inputs)
	if (locale === "es") return es_keep_window_open_until_upload_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_keep_window_open_until_upload_complete(inputs)
	if (locale === "ja") return ja_keep_window_open_until_upload_complete(inputs)
	if (locale === "hi") return hi_keep_window_open_until_upload_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_keep_window_open_until_upload_complete(inputs)
	return en_keep_window_open_until_upload_complete(inputs)
});